import { ObservableMap } from 'owa-mobx4-adapter';
import { createStore } from 'satcheljs';
var sharingLinkStore = {
    sharingLinks: new ObservableMap({}),
};
export var getStore = createStore('sharingLinkStore', sharingLinkStore);
export default getStore;
//# sourceMappingURL=store.js.map